import React, { Component } from 'react';
import { connect } from 'react-redux';
import Formsy from 'formsy-react';
import { hideBalanceModal, createTransaction } from '../balance.actions';
import translator from '../../../components/localization/translator';
import { Modal } from 'react-bootstrap';
import EditableField from './EditableField';
import FooterButtons from '../../../components/common/elements/FooterButtons';
import balanceConfig from '../../../config/balance';
import RadioGroup from '../../../components/common/elements/RadioGroup';

class BalanceDetails extends Component {
    constructor(props) {
        super(props);
        this.state ={
            action: balanceConfig.transactionTypes.INPUT
        };
        this.changedData = {};
        this.cancel = this.cancel.bind(this);
        this.save = this.save.bind(this);
        this.setChangedData = this.setChangedData.bind(this);
        this.renderRadioGroup = this.renderRadioGroup.bind(this);
    }

    setChangedData(key, value) {
        this.changedData[key] = value;
    }

    save() {
        const input = this.state.action ===  balanceConfig.transactionTypes.OUTPUT ? -1 * this.changedData.input: this.changedData.input;
        this.setState({action: balanceConfig.transactionTypes.INPUT});
        const data = {
            distributor: this.props.balanceDetails.distributor,
            input,
            comment: this.changedData.comment
        };
        this.props.createTransaction(data, this.cancel.bind(this));
    }

    cancel() {
		this.changedData = {};
		this.props.hideBalanceModal();
    }

    renderRadioGroup(transaction) {
        return (
			<RadioGroup
                id={transaction.name}
				name={"input/output"}
                key={transaction.type}
				title={translator.translate(transaction.name)}
				checked={transaction.type === balanceConfig.transactionTypes.INPUT}
                onClick={ (e) => {
					this.setState({action: transaction.type})
                }}
				customClass="margin-to-right"
				customRadioClass="to-right"
				customRadioSpanClass="inline-block" />
		);
    }

    renderFooter() {
		return (
			<Modal.Footer>
				<FooterButtons
					cancelButton={translator.translate("_cancel_")}
					saveButton={translator.translate("_save_")}
					save={this.save}
					cancel={this.cancel}
                    />
			</Modal.Footer>
		);
	}

    render() {
        return (
            <Modal
                bsSize='large'
                show={this.props.balanceDetails.show}
                onHide={this.cancel.bind(this)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{translator.translate('_create_transaction_')}
					</Modal.Title>
				</Modal.Header>
                <Modal.Body className="scrollable modal-possition">
                    <Formsy>
                        <EditableField
                            setChangedData={this.setChangedData}/>
					</Formsy>
                    {this.renderRadioGroup({
                        name: "_input_",
                        type: balanceConfig.transactionTypes.INPUT
                    })}
                    {this.renderRadioGroup({
                        name: "_output_",
                        type: balanceConfig.transactionTypes.OUTPUT
                    })}
				</Modal.Body>
                {this.renderFooter()}
			</Modal>
        );
    }
}

let mapStateToProps = (state) => {
    return {
        balanceDetails: state.balanceDetails
    };
};
export default connect(mapStateToProps, {
    hideBalanceModal,
    createTransaction
})(BalanceDetails);
